"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackAnalyticsEvent = void 0;
const pushToDataLayer_1 = require("./pushToDataLayer");
const clearGA4EventData_1 = require("./clearGA4EventData");
function trackAnalyticsEvent({ category, action, label, value, nonInteraction, eventData, activeValues, }) {
    const analyticsEvent = {
        event: 'JS_Event',
        eventCategory: category,
        eventAction: action,
        eventLabel: label,
        eventValue: value,
        nonInteraction,
        ...(eventData ? { eventData } : undefined),
        active_filter_types: activeValues,
    };
    if (eventData) {
        (0, clearGA4EventData_1.clearGA4EventData)();
    }
    (0, pushToDataLayer_1.pushToDataLayer)(analyticsEvent);
}
exports.trackAnalyticsEvent = trackAnalyticsEvent;
//# sourceMappingURL=trackAnalyticsEvent.js.map